import { Component, inject, OnInit } from "@angular/core";
import { BridgeService } from "@vega/bridge";
import { ILogger, LoggerFactory } from "@vega/logging";
import * as AppSettings from "../environments/app-settings";
import { RouterOutlet } from "@angular/router";
import { LoadingWindowComponent } from "@vega/ui-toolbox/loading-window";
import { TRANSLATE_SERVICE } from "@vega/localization";
import { Title } from "@angular/platform-browser";

@Component({
    selector: "vega-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.less"],
    imports: [RouterOutlet, LoadingWindowComponent]
})
export class AppComponent implements OnInit {
    private _bridgeService = inject(BridgeService);
    private _translateService = inject(TRANSLATE_SERVICE);
    private cefBridgeService = inject(BridgeService);
    private _title = inject(Title);
    public version = "1.0.0";
    public isTopVisEmbedded: boolean;

    private _logger: ILogger;

    constructor() {
        const loggerFactory = inject(LoggerFactory);

        this.cefBridgeService.initialize();
        this.isTopVisEmbedded = this.cefBridgeService.isBridgeActive;
        this._logger = loggerFactory.getLogger(AppComponent.name);
    }

    public ngOnInit(): void {
        this._bridgeService.initialize();

        this._logger.info(`The application version is: ${this.version}`);
        this._logger.info("The current configuration for the environment is:", AppSettings.appSettings);
        this._logger.info(
            "The current configuration for the locking is:",
            AppSettings.appConfiguration.lockingConfiguration
        );
        this._logger.info("The current configuration for the application is:", AppSettings.appConfiguration);

        this._title.setTitle(this._translateService.instant("APPLICATION.TITLE"));
    }
}
